export const archiveDisplayName = "JS6lcd";
export default {archiveDisplayName};